import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startUnlock = async (requestId) => {
  const { data } = await axios.post(`${API}/public/checkout`, {
    kind: "sblocco",
    request_id: requestId,
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
};
